import { useTranslation } from 'react-i18next';
import { Popup } from 'semantic-ui-react';

export default function Tooltip({ node, text }) {
  const { t } = useTranslation();
  return <Popup inverted disabled={false} content={t(text)} trigger={node} />;
}
